import styled from '@emotion/styled'

interface DashboardCardProps {
    children: React.ReactNode
    title?: string
    icon?: React.ReactNode
}

const CardContainer = styled.div`
    background: white;
    border-radius: 8px;
    box-shadow:
        0 1px 3px rgba(0, 0, 0, 0.1),
        0 1px 2px rgba(0, 0, 0, 0.06);
    padding: 24px;
    transition:
        box-shadow 0.2s ease,
        transform 0.2s ease;
    height: 100%;
    overflow: auto;

    &:hover {
        box-shadow:
            0 4px 6px rgba(0, 0, 0, 0.1),
            0 2px 4px rgba(0, 0, 0, 0.06);
        transform: translateY(-2px);
    }
`

const CardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e5e7eb;
`

const CardTitle = styled.h3`
    font-size: 1.8rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
`

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #fee2e2;
    border-radius: 8px;
    color: #b40000;
    font-size: 1.8rem;
`

const CardContent = styled.div`
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #b40000;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #991b1b;
    }
`

const DashboardCard = ({ children, title, icon }: DashboardCardProps) => {
    return (
        <CardContainer>
            {title && (
                <CardHeader>
                    {icon && <IconWrapper>{icon}</IconWrapper>}
                    <CardTitle>{title}</CardTitle>
                </CardHeader>
            )}
            <CardContent>{children}</CardContent>
        </CardContainer>
    )
}

export default DashboardCard
